import GeolocalisationDsfr from "components/templates/geolocalisationDsfr/GeolocalisationDsfr";
import elementsTypes from "utils/elementsTypes";
import geolocSourceType from "utils/geolocSourceType";

export default {
  key: "GEOLOCALISATIONDSFR",
  label: "Geolocalisation (DSFR)",
  Component: GeolocalisationDsfr,
  initialContents: [
    {
      key: "source",
      type: elementsTypes.GEOLOC_SOURCETYPE,
      value: geolocSourceType.PHOTOGRAPHE,
    },
    {
      key: "bottomDynamicPart",
      type: elementsTypes.DYNAMIC,
      value: "",
      children: [],
    },
  ],
};
